<template>
  <div class="contact-page">
    <div class="container contact-page__container">
      <section class="contact-page__intro">
        <p class="contact-page__eyebrow">Parlons de votre projet</p>
        <h2 class="contact-page__title">
          Contactez votre centre de formations vtc et taxi
        </h2>
        <p class="contact-page__copy">
          Vous souhaitez <strong>devenir chauffeur de taxi</strong>, obtenir la
          <strong>carte professionnelle vtc</strong> ou suivre une
          <strong>formation continue</strong> ? Nous vous aidons a choisir la
          bonne formule, a comprendre le financement et a lancer votre dossier
          sans perdre de temps.
        </p>

        <div class="contact-page__quick-actions">
          <a
            v-for="action in quickActions"
            :key="action.title"
            :href="action.href"
            class="contact-page__quick-card"
            :target="action.external ? '_blank' : null"
            :rel="action.external ? 'noopener noreferrer' : null"
          >
            <span class="contact-page__quick-icon" aria-hidden="true">
              <i :class="action.icon"></i>
            </span>
            <span class="contact-page__quick-text">
              <strong>{{ action.title }}</strong>
              <span>{{ action.subtitle }}</span>
            </span>
          </a>
        </div>
      </section>

      <div class="contact-page__main">
        <article class="contact-panel contact-panel--form left-form slide-left">
          <header class="contact-panel__header">
            <p class="contact-panel__eyebrow">Message direct</p>
            <h3>Ecrivez-nous</h3>
            <p>
              Posez votre question, decrivez votre situation et nous vous
              recontactons rapidement avec une reponse claire.
            </p>
          </header>

          <form ref="formData" class="contact-form" @submit.prevent="sendEmail">
            <div class="contact-form__grid">
              <div class="contact-field">
                <label for="name">Nom</label>
                <div class="contact-field__control">
                  <span class="contact-field__icon" aria-hidden="true">
                    <i class="fas fa-user"></i>
                  </span>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    class="form-control"
                    maxlength="30"
                    autocomplete="name"
                    required
                  />
                </div>
              </div>

              <div class="contact-field">
                <label for="email">Email</label>
                <div class="contact-field__control">
                  <span class="contact-field__icon" aria-hidden="true">
                    <i class="fas fa-envelope"></i>
                  </span>
                  <input
                    id="email"
                    type="text"
                    name="email"
                    class="form-control"
                    autocomplete="email"
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                    required
                  />
                </div>
              </div>

              <div class="contact-field">
                <label for="phone">Telephone</label>
                <div class="contact-field__control">
                  <span class="contact-field__icon" aria-hidden="true">
                    <i class="fas fa-phone"></i>
                  </span>
                  <input
                    id="phone"
                    type="tel"
                    name="phone"
                    class="form-control"
                    autocomplete="tel"
                    inputmode="tel"
                    pattern="^(\+?\d{1,3}[- ]?)?\d{10}$"
                    required
                  />
                </div>
              </div>

              <div class="contact-field">
                <label for="reason">Sujet</label>
                <div class="contact-field__control">
                  <span class="contact-field__icon" aria-hidden="true">
                    <i class="fas fa-tag"></i>
                  </span>
                  <input
                    id="reason"
                    type="text"
                    name="reason"
                    class="form-control"
                    placeholder="Renseignements, inscription, financement..."
                    pattern="^[^/<>\n]*$"
                    required
                  />
                </div>
              </div>

              <div class="contact-field contact-field--message">
                <label for="message">Message</label>
                <div
                  class="contact-field__control contact-field__control--textarea"
                >
                  <span class="contact-field__icon" aria-hidden="true">
                    <i class="fas fa-pencil-alt"></i>
                  </span>
                  <textarea
                    id="message"
                    name="message"
                    class="form-control"
                    rows="5"
                    maxlength="450"
                    placeholder="Precisez votre besoin pour que l'on puisse vous orienter vers la bonne formation."
                    pattern="^[^/<>\n]*$"
                    required
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="contact-panel__footer">
              <div class="contact-panel__actions">
                <button
                  name="contactBtn"
                  class="contact-panel__submit"
                  :disabled="SendingEmail"
                >
                  {{
                    SendingEmail ? "Envoi en cours..." : "Envoyer ma demande"
                  }}
                </button>
              </div>

              <p v-if="EmailError" class="contact-panel__status">
                Une erreur est survenue pendant l'envoi. Reessayez ou appelez le
                centre directement.
              </p>
            </div>
          </form>

          <div class="contact-panel__support">
            <div class="contact-support">
              <p class="contact-support__eyebrow">Besoin d'un point rapide ?</p>
              <h4>Nous pouvons deja vous orienter sur l'essentiel</h4>
              <ul class="contact-support__list">
                <li>
                  Choisir entre formation initiale, continue, pratique ou
                  mobilite.
                </li>
                <li>
                  Identifier le bon rythme selon votre planning: journee, soir
                  ou week-end.
                </li>
                <li>
                  Comprendre les solutions de financement et les prochaines
                  etapes.
                </li>
              </ul>
            </div>
          </div>

          <span v-if="modalConfirm">
            <ConfirmModal
              @closeModalConfirm="closeModalConfirm"
              title="Merci de votre intérêt"
              message="Vous allez être recontactés dans les plus brefs délais"
              btnExit="À bientôt"
            />
          </span>
        </article>

        <article
          class="contact-panel contact-panel--booking right-form slide-right"
        >
          <header class="contact-panel__header contact-panel__header--dark">
            <p class="contact-panel__eyebrow">Rendez-vous</p>
            <h3>Reserve un echange</h3>
            <p>
              Choisissez un creneau pour faire le point sur votre projet de
              formation et avancer plus vite.
            </p>
          </header>

          <div class="contact-panel__points">
            <div
              v-for="point in bookingPoints"
              :key="point.title"
              class="contact-point"
            >
              <span class="contact-point__icon" aria-hidden="true">
                <i :class="point.icon"></i>
              </span>
              <div class="contact-point__body">
                <strong>{{ point.title }}</strong>
                <span>{{ point.text }}</span>
              </div>
            </div>
          </div>

          <div id="calendar" class="contact-panel__calendar">
            <CalendlyVue />
          </div>
        </article>
      </div>

      <section class="contact-location fall">
        <div class="contact-location__copy">
          <p class="contact-location__eyebrow">Venir au centre</p>
          <h3>Retrouvez l'Institut Taxi a Gennevilliers</h3>
          <p>
            Le centre vous accueille a Gennevilliers, dans les Hauts-de-Seine,
            pour vos rendez-vous, vos formations et vos demarches
            administratives.
          </p>

          <div class="contact-location__tags">
            <span>10 rue de la Sabliere</span>
            <span>92230 Gennevilliers</span>
            <span>Hauts-de-Seine (92)</span>
          </div>

          <div class="contact-location__actions">
            <a
              :href="googleMapsUrl"
              class="contact-location__action contact-location__action--primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ouvrir l'itineraire
            </a>
            <a
              href="tel:+33141112232"
              class="contact-location__action contact-location__action--secondary"
            >
              Appeler le centre
            </a>
          </div>
        </div>

        <div id="map-container-section" class="contact-location__map">
          <iframe
            loading="lazy"
            title="Institut Taxi Gennevilliers"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=10%20Rue%20de%20la%20Sabli%C3%A8re,%2092230%20Gennevilliers+(l'Institut%20Taxi)&amp;t=k&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </div>
      </section>

      <section class="contact-connect fall">
        <header class="contact-connect__header">
          <p class="contact-connect__eyebrow">Restons en lien</p>
          <h3>L'Institut <span>Taxi</span></h3>
        </header>

        <div class="contact-connect__grid">
          <ContactCard />
          <SocialMedia />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import ContactCard from "@/components/partials/ContactCard.vue";
import SocialMedia from "@/components/partials/SocialMedia.vue";
import CalendlyVue from "@/components/plugins/CalendlyVue.vue";

const quickActions = [
  {
    title: "Appeler le centre",
    subtitle: "01 41 11 22 32",
    href: "tel:+33141112232",
    icon: "fas fa-phone",
  },
  {
    title: "Envoyer un email",
    subtitle: "contact@institut-taxi.fr",
    href: "mailto:contact@institut-taxi.fr",
    icon: "fas fa-envelope",
  },
  {
    title: "Prendre rendez-vous",
    subtitle: "Creneau direct via Calendly",
    href: "#calendar",
    icon: "fas fa-calendar-alt",
  },
];

const bookingPoints = [
  {
    title: "Choisissez un creneau",
    text: "Selectionnez directement le moment le plus pratique pour vous.",
    icon: "fas fa-clock",
  },
  {
    title: "Faites le point sur votre projet",
    text: "Formation, financement, planning ou inscription: nous vous orientons rapidement.",
    icon: "fas fa-comments",
  },
];

export default {
  name: "contactForm",
  components: {
    ContactCard,
    SocialMedia,
    ConfirmModal,
    CalendlyVue,
  },
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(".slide-right", ".slide-left", ".fall");
    });
  },
  data() {
    return {
      modalConfirm: false,
      quickActions,
      bookingPoints,
      googleMapsUrl:
        "https://www.google.com/maps/search/?api=1&query=10+Rue+de+la+Sabliere+92230+Gennevilliers",
    };
  },
  computed: {
    ...mapGetters({
      SendingEmail: "StateSendingEmail",
      EmailSent: "StateEmailSent",
      EmailError: "StateEmailError",
    }),
  },
  methods: {
    ...mapActions(["SendContactEmail"]),
    sendEmail() {
      this.SendContactEmail(this.$refs.formData);
      this.modalConfirm = true;
      this.$refs.formData.reset();
    },
    closeModalConfirm() {
      this.modalConfirm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-page {
  padding: clamp(42px, 5vw, 76px) 0 96px;

  &__container {
    display: grid;
    gap: clamp(30px, 4vw, 48px);
  }

  &__intro {
    display: grid;
    gap: 18px;
    justify-items: center;
    text-align: center;
    width: min(100%, 980px);
    margin: 0 auto;
  }

  &__eyebrow {
    margin: 0;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: rgba(0, 42, 84, 0.56);
  }

  &__title {
    margin: 0;
    color: $color-primary;
    font-size: clamp(2rem, 3vw, 3.35rem);
    line-height: 1.03;
  }

  &__copy {
    width: min(100%, 860px);
    margin: 0;
    font-size: 1.02rem;
    line-height: 1.8;
    color: $color-text;
  }

  &__main {
    display: grid;
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
    gap: 22px;
    align-items: stretch;
  }

  &__quick-actions {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    width: min(100%, 1120px);
  }

  &__quick-card {
    display: flex;
    align-items: center;
    gap: 14px;
    min-height: 86px;
    padding: 16px 18px;
    border-radius: 22px;
    background: #ffffff;
    border: 1px solid rgba(0, 42, 84, 0.08);
    box-shadow: 0 16px 34px rgba(0, 42, 84, 0.07);
    text-decoration: none;
    transition: transform 0.22s ease, box-shadow 0.22s ease,
      border-color 0.22s ease;

    &:hover,
    &:focus-visible {
      transform: translateY(-2px);
      border-color: rgba(254, 185, 20, 0.34);
      box-shadow: 0 20px 36px rgba(0, 42, 84, 0.1);
      outline: none;
    }
  }

  &__quick-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 18px;
    background: $color-primary;
    color: $color-secondary;
    flex: 0 0 auto;

    & i {
      font-size: 1.15rem;
    }
  }

  &__quick-text {
    display: grid;
    gap: 4px;
    min-width: 0;

    & strong {
      font-size: 0.96rem;
      line-height: 1.2;
      color: $color-primary;
    }

    & span {
      font-size: 0.9rem;
      line-height: 1.35;
      color: rgba(88, 89, 91, 0.94);
      overflow-wrap: anywhere;
    }
  }
}

.contact-panel {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: clamp(24px, 2.8vw, 34px);
  border-radius: 30px;
  min-height: 100%;

  &--form {
    background: $color-primary;
    color: $color-text-light;
    box-shadow: 0 28px 54px rgba(0, 42, 84, 0.18);
  }

  &--booking {
    background: $color-secondary;
    color: $color-primary;
    box-shadow: 0 24px 46px rgba(254, 185, 20, 0.18);
  }

  &__header {
    display: grid;
    gap: 10px;

    h3 {
      margin: 0;
      font-size: clamp(1.7rem, 1.35rem + 0.6vw, 2.2rem);
      line-height: 1.04;
      color: inherit;
    }

    p:last-child {
      margin: 0;
      font-size: 0.98rem;
      line-height: 1.7;
      color: rgba(245, 236, 236, 0.86);
    }
  }

  &__header--dark p:last-child {
    color: rgba(0, 0, 0, 0.76);
  }

  &__eyebrow {
    margin: 0;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(245, 236, 236, 0.66);
  }

  &--booking &__eyebrow {
    color: rgba(0, 42, 84, 0.58);
  }

  &__footer {
    display: grid;
    gap: 16px;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }

  &__submit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 220px;
    min-height: 56px;
    padding: 0 24px;
    border: 0;
    border-radius: 18px;
    background: $color-secondary;
    color: $color-primary;
    font-size: 0.92rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.22);
    transition: transform 0.2s ease, box-shadow 0.2s ease,
      background-color 0.2s ease;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      transform: translateY(-1px);
      background: darken($color-secondary, 4%);
      box-shadow: 0 18px 30px rgba(0, 0, 0, 0.24);
      outline: none;
    }

    &:disabled {
      opacity: 0.68;
      cursor: wait;
    }
  }

  &__status {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.86);
  }

  &__support {
    margin-top: 4px;
  }

  &__points {
    display: grid;
    gap: 12px;
  }

  &__calendar {
    padding: 14px;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.52);
    box-shadow: inset 0 0 0 1px rgba(0, 42, 84, 0.08);
  }
}

.contact-form {
  display: grid;
  gap: 24px;

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
  }
}

.contact-field {
  display: grid;
  gap: 8px;

  &--message {
    grid-column: 1 / -1;
  }

  label {
    margin: 0;
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(245, 236, 236, 0.76);
  }

  &__control {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 62px;
    padding: 0 16px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);

    input,
    textarea {
      width: 100%;
      border: 0;
      background: transparent;
      color: $color-text-light;
      box-shadow: none;
      padding: 0;

      &::placeholder {
        color: rgba(245, 236, 236, 0.48);
      }

      &:focus {
        box-shadow: none;
        background: transparent;
        color: $color-text-light;
      }
    }
  }

  &__control--textarea {
    align-items: flex-start;
    padding-top: 16px;
    padding-bottom: 16px;

    textarea {
      resize: vertical;
      min-height: 128px;
    }
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 14px;
    background: rgba(254, 185, 20, 0.18);
    color: $color-secondary;
    flex: 0 0 auto;
  }
}

.contact-point {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.38);
  border: 1px solid rgba(0, 42, 84, 0.08);

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 16px;
    background: $color-primary;
    color: $color-secondary;
    flex: 0 0 auto;
  }

  &__body {
    display: grid;
    gap: 4px;

    & strong {
      font-size: 0.94rem;
      line-height: 1.2;
      color: $color-primary;
    }

    & span {
      font-size: 0.9rem;
      line-height: 1.45;
      color: rgba(0, 0, 0, 0.76);
    }
  }
}

.contact-support {
  display: grid;
  gap: 12px;
  padding: 20px 22px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);

  &__eyebrow {
    margin: 0;
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(245, 236, 236, 0.68);
  }

  & h4 {
    margin: 0;
    color: $color-text-light;
    font-size: 1.2rem;
    line-height: 1.25;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 10px;

    & li {
      position: relative;
      padding-left: 18px;
      font-size: 0.94rem;
      line-height: 1.55;
      color: rgba(245, 236, 236, 0.84);

      &::before {
        content: "";
        position: absolute;
        top: 0.62rem;
        left: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: $color-secondary;
      }
    }
  }
}

.contact-location {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 22px;
  align-items: stretch;

  &__copy,
  &__map {
    min-height: 100%;
    border-radius: 30px;
    overflow: hidden;
  }

  &__copy {
    display: grid;
    align-content: start;
    gap: 18px;
    padding: clamp(24px, 2.8vw, 34px);
    background: #ffffff;
    border: 1px solid rgba(0, 42, 84, 0.08);
    box-shadow: 0 18px 42px rgba(0, 42, 84, 0.08);

    h3 {
      margin: 0;
      color: $color-primary;
      font-size: clamp(1.7rem, 1.35rem + 0.5vw, 2.1rem);
      line-height: 1.04;
    }

    p:last-of-type {
      margin: 0;
      font-size: 0.98rem;
      line-height: 1.7;
      color: $color-text;
    }
  }

  &__eyebrow {
    margin: 0;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(0, 42, 84, 0.56);
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    & span {
      display: inline-flex;
      align-items: center;
      min-height: 38px;
      padding: 0 14px;
      border-radius: 999px;
      background: rgba(0, 42, 84, 0.05);
      color: $color-primary;
      font-size: 0.88rem;
      font-weight: 600;
    }
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  &__action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    padding: 0 20px;
    border-radius: 18px;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    transition: transform 0.2s ease, box-shadow 0.2s ease,
      background-color 0.2s ease, color 0.2s ease;

    &:hover,
    &:focus-visible {
      transform: translateY(-1px);
      outline: none;
    }
  }

  &__action--primary {
    background: $color-primary;
    color: $color-secondary;
    box-shadow: 0 14px 26px rgba(0, 42, 84, 0.16);
  }

  &__action--secondary {
    background: $color-secondary;
    color: $color-primary;
    box-shadow: 0 14px 26px rgba(254, 185, 20, 0.18);
  }

  &__map {
    position: relative;
    min-height: 430px;
    box-shadow: 0 22px 42px rgba(0, 42, 84, 0.12);

    iframe {
      width: 100%;
      height: 100%;
      border: 0;
      display: block;
    }
  }
}

.contact-connect {
  display: grid;
  gap: 18px;

  &__header {
    display: grid;
    gap: 8px;
    justify-items: center;
    text-align: center;

    h3 {
      margin: 0;
      color: $color-primary;
      font-size: clamp(2rem, 2.4vw, 2.8rem);
      line-height: 1.02;

      span {
        color: $color-secondary;
      }
    }
  }

  &__eyebrow {
    margin: 0;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(0, 42, 84, 0.56);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 22px;
    align-items: stretch;
  }
}

@media screen and (max-width: 991px) {
  .contact-page {
    &__main,
    &__quick-actions,
    .contact-connect__grid,
    .contact-location {
      grid-template-columns: 1fr;
    }
  }

  .contact-panel__actions {
    flex-direction: column;
    align-items: stretch;
  }

  .contact-panel__submit {
    width: 100%;
  }

  .contact-location__map {
    min-height: 360px;
  }
}

@media screen and (max-width: 767px) {
  .contact-page {
    padding: 32px 0 72px;

    &__container {
      gap: 26px;
    }

    &__quick-card {
      min-height: 78px;
      padding: 14px 16px;
      border-radius: 20px;
    }
  }

  .contact-panel,
  .contact-location__copy,
  .contact-location__map {
    padding: 22px;
    border-radius: 24px;
  }

  .contact-panel--booking {
    padding-bottom: 22px;
  }

  .contact-form__grid {
    grid-template-columns: 1fr;
  }

  .contact-field__control {
    min-height: 58px;
  }

  .contact-location__map {
    min-height: 300px;
    padding: 0;
  }
}
</style>
